<template>
    <div :style="'margin-bottom: '+footbottom+'px;'" class=" bg-round bg-fff pa-t-10">
        <div class="container" id="app" v-cloak>
            <h2 class="t-center mt-20 bold">{{pageTitle}}</h2>

            <div class="form" v-show="step==0">
                <div class="bold form-title">
                    个人资料
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Name')">
                    <div class="col-md-2 t-md-right">姓名</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.Name" placeholder=""></el-input>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Gender')">
                    <div class="col-md-2 t-md-right">性别</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.Gender">
                            <el-radio label="男"></el-radio>
                            <el-radio label="女"></el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Company')">
                    <div class="col-md-2 t-md-right">毕业学校/单位</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.Company" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoRole') && typeId==0">
                    <div class="col-md-2 t-md-right">本人是这部作品的</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.VideoRole">
                            <el-radio label="导演"></el-radio>
                            <el-radio label="制片"></el-radio>
                            <el-radio label="其他"></el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoRole') && typeId==1">
                    <div class="col-md-2 t-md-right">本人是这部作品的</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.VideoRole">
                            <el-radio label="编剧"></el-radio>
                            <el-radio label="制片"></el-radio>
                            <el-radio label="导演"></el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoRole') && typeId==4">
                    <div class="col-md-2 t-md-right">申请者类别</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.VideoRole">
                            <el-radio label="短片创作者"></el-radio>
                            <el-radio label="原创音乐人"></el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'OccupationalStatus') && typeId==2">
                    <div class="col-md-2 t-md-right">影评人职业状态</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.OccupationalStatus">
                            <el-radio label="职业"></el-radio>
                            <el-radio label="非职业"></el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'OccupationalStatus') && typeId==3">
                    <div class="col-md-2 t-md-right">职业状态</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.OccupationalStatus">
                            <el-radio label="职业"></el-radio>
                            <el-radio label="非职业"></el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="row f-center">
                    <div class="col-md-2 t-md-right" v-if="Object.hasOwnProperty.call(formData,'Nation')">民族</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.Nation" placeholder=""></el-input>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Email')">
                    <div class="col-md-2 t-md-right">电子邮箱</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.Email" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Phone')">
                    <div class="col-md-2 t-md-right">手机号码</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.Phone" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'WxAccount')">
                    <div class="col-md-2 t-md-right">微信号</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.WxAccount" placeholder=""></el-input>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Resume') && typeId==0">
                    <div class="col-md-2 t-md-right">导演简历（800字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Resume" maxlength="800" show-word-limit
                            rows="8">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Resume') && typeId==1">
                    <div class="col-md-2 t-md-right">编剧简历（800字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Resume" maxlength="800" show-word-limit
                            rows="8">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Resume') && typeId==2">
                    <div class="col-md-2 t-md-right">影评人简历（800字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Resume" maxlength="800" show-word-limit
                            rows="8">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Resume') && typeId==3">
                    <div class="col-md-2 t-md-right">艺术家简历（800字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Resume" maxlength="800" show-word-limit
                            rows="8">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Resume') && typeId==4">
                    <div class="col-md-2 t-md-right">创作者简历（800字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Resume" maxlength="800" show-word-limit
                            rows="8">
                        </el-input>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Prize')">
                    <div class="col-md-2 t-md-right">荣誉/奖项</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Prize" rows="4">
                        </el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Headimage')">
                    <div class="col-md-2 t-md-right">个人相片</div>
                    <div class="col-md-5">
                        <el-upload action="http://api.shisw.net/V1/Common/AliyunOSS/Base64Upload" 
                            ref="uploadHeadimageHeadimage" :show-file-list="true" :http-request="httpRequest" data="Headimage"
                            list-type="picture" :before-upload="beforeAvatarUploadHeadimage" :on-remove="handleRemove"
                            onsuccess="handSuccess" :limit="1" :file-list="fileList.Headimage">
                            <div class="btn-upload">上传图片</div>
                            <div slot="tip" class="el-upload__tip">1张，3MB以内</div>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div class="form" v-show="step==1">
                <div class="bold form-title">
                    <span v-if="typeId==2 || typeId==4">影片介绍</span>
                    <span v-if="typeId==0 || typeId==1 || typeId==3">作品资料</span>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoName') && (typeId==0 || typeId==1)">
                    <div class="col-md-2 t-md-right">
                        作品名称（中英文）</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.VideoName" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'FilmcriticsTitle')">
                    <div class="col-md-2 t-md-right">
                        影评文章名称</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.FilmcriticsTitle" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoName') && (typeId==3 || typeId==4)">
                    <div class="col-md-2 t-md-right">
                        作品名称</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.VideoName" placeholder=""></el-input>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoDuration') && typeId==0">
                    <div class="col-md-2 t-md-right">
                        影片时长</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.VideoDuration" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoDuration') && typeId==1">
                    <div class="col-md-2 t-md-right">
                        预计片长</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.VideoDuration" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoDuration') && typeId==3">
                    <div class="col-md-2 t-md-right">
                        预计片长</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.VideoDuration" placeholder=""></el-input>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoDuration') && typeId==4">
                    <div class="col-md-2 t-md-right">
                        时长</div>
                    <div class="col-md-5">
                        <el-input v-model="formData.VideoDuration" placeholder=""></el-input>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'CompleteTime') && (typeId==0 || typeId==1)">
                    <div class="col-md-2 t-md-right">
                        完成时间</div>
                    <div class="col-md-5">
                        <el-date-picker v-model="formData.CompleteTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期">
                        </el-date-picker>
                        <!-- <el-input v-model="formData.CompleteTime" placeholder=""></el-input> -->
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoOverTime') && (typeId==3 || typeId==4)">
                    <div class="col-md-2 t-md-right">
                        预计完成时间</div>
                    <div class="col-md-5">
                        <el-date-picker v-model="formData.VideoOverTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" default-time="12:00:00">
                        </el-date-picker>
                        <!-- <el-input v-model="formData.VideoOverTime" placeholder=""></el-input> -->
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'FilmcriticsTime') && typeId==2">
                    <div class="col-md-2 t-md-right">
                        影评完成时间</div>
                    <div class="col-md-5">
                        <el-date-picker v-model="formData.FilmcriticsTime" type="date" value-format="yyyy-MM-dd"
                            placeholder="选择日期" default-time="12:00:00">
                        </el-date-picker>
                        <!-- <el-input v-model="formData.FilmcriticsTime" placeholder=""></el-input> -->
                    </div>
                </div>


                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoCategory')">
                    <div class="col-md-2 t-md-right">作品类型</div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.VideoCategory">
                            <el-radio label="剧情"></el-radio>
                            <el-radio label="记录"></el-radio>
                            <el-radio label="实验"></el-radio>
                            <el-radio label="动画"></el-radio>
                            <el-radio label="长片"></el-radio>
                            <el-radio label="短片"></el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'VideoLanguage')">
                    <div class="col-md-2 t-md-right">故事语言
                    </div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.VideoLanguage">
                            <el-radio label="普通话"></el-radio>
                            <el-radio label="地域方言"></el-radio>
                            <el-radio label="英文"></el-radio>
                            <el-radio label="无声"></el-radio>
                            <el-radio label="其他"></el-radio>
                        </el-radio-group>
                    </div>
                </div>



                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Subtitle')">
                    <div class="col-md-2 t-md-right">字幕
                    </div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.Subtitle">
                            <el-radio label="中文"></el-radio>
                            <el-radio label="英文"></el-radio>
                            <el-radio label="中英双轨"></el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'AgreeJoinSHISW')">
                    <div class="col-md-2 t-md-right">如果您的作品入选是否同意加入
                        “SHISW线上影展”
                    </div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.AgreeJoinSHISW">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Simple')">
                    <div class="col-md-2 t-md-right">一句话梗概（50字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Simple" maxlength="50" show-word-limit
                            rows="2">
                        </el-input>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Summary') && (typeId==0)">
                    <div class="col-md-2 t-md-right">故事简介（500字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Summary" maxlength="500" show-word-limit
                            rows="5">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Summary') && (typeId==1)">
                    <div class="col-md-2 t-md-right">创作简介（长片1000字内；短片50字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Summary" rows="5">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Summary') && (typeId==3)">
                    <div class="col-md-2 t-md-right">作品简介（长片1000字内；短片500字内）</div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Summary" rows="5">
                        </el-input>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Elaboration') && typeId==0">
                    <div class="col-md-2 t-md-right">导演阐述（300字内） </div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Elaboration" maxlength="300"
                            show-word-limit rows="3">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Elaboration') && (typeId==1 || typeId==3)">
                    <div class="col-md-2 t-md-right">创作阐述（500字内） </div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Elaboration" maxlength="500"
                            show-word-limit rows="3">
                        </el-input>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'Elaboration') && typeId==4">
                    <div class="col-md-2 t-md-right">短片创作者填写创作阐述/原创音乐人填写创作理念（500字以内） </div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.Elaboration" rows="5" maxlength="500" show-word-limit>
                        </el-input>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Poster')">
                    <div class="col-md-2 t-md-right">海报</div>
                    <div class="col-md-5">
                        <el-upload action="http://api.shisw.net/V1/Common/AliyunOSS/Base64Upload" data="Poster"
                            :http-request="httpRequest" list-type="picture" :before-upload="beforeAvatarUploadPoster"
                            :on-remove="handleRemove" onsuccess="handSuccess" :file-list="fileList.Poster" :limit="2">
                            <div class="btn-upload">上传图片</div>
                            <div slot="tip" class="el-upload__tip">1-2张，每张5MB以内</div>
                        </el-upload>
                    </div>
                </div>
                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'Stills')">
                    <div class="col-md-2 t-md-right">剧照</div>
                    <div class="col-md-5">
                        <el-upload action="http://api.shisw.net/V1/Common/AliyunOSS/Base64Upload" data="Stills"
                            :http-request="httpRequest" list-type="picture" :before-upload="beforeAvatarUploadStills"
                            :on-remove="handleRemove" onsuccess="handSuccess" :file-list="fileList.Stills" :limit="5">
                            <div class="btn-upload">上传图片</div>
                            <div slot="tip" class="el-upload__tip">3-5张，每张5MB以内</div>

                        </el-upload>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'FilmcriticsWords')">
                    <div class="col-md-2 t-md-right">字数</div>
                    <div class="col-md-10">
                        <el-input type="Number" placeholder="" v-model="formData.FilmcriticsWords">
                        </el-input>
                    </div>
                </div>

                <div class="row " v-if="Object.hasOwnProperty.call(formData,'FilmcriticsVideoName')">
                    <div class="col-md-2 t-md-right">影评电影名称</div>
                    <div class="col-md-10">
                        <el-input type="text" placeholder="" v-model="formData.FilmcriticsVideoName">
                        </el-input>
                    </div>
                </div>

                <div class="row f-center" v-if="Object.hasOwnProperty.call(formData,'FilmcriticsVideoType')">
                    <div class="col-md-2 t-md-right">影评电影片长类型
                    </div>
                    <div class="col-md-5">
                        <el-radio-group v-model="formData.FilmcriticsVideoType">
                            <el-radio label="长片"></el-radio>
                            <el-radio label="短片"></el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="row " v-if="Object.hasOwnProperty.call(formData,'FilmcriticsContent')">
                    <div class="col-md-2 t-md-right">影评正文（300-2500字以内） </div>
                    <div class="col-md-10">
                        <el-input type="textarea" placeholder="" v-model="formData.FilmcriticsContent" rows="10"
                            maxlength="2500">
                        </el-input>
                    </div>
                </div>

            </div>
            <div class="form" v-show="step==2">
                <div class="bold form-title">
                    参赛须知与授权
                </div>

                <div v-if="typeId==0">
                    提交报名申请前，请您确认以下内容并选择同意授权：<br>
                    1、凡提交作品参展，即表示报名者同意接受SHISW组委会制定之所有参展细则章程。<br>
                    报名者一旦正式提交申请，即不得以任何理由擅自撤回已入选的作品；<br>
                    2、报名应确认对提交的作品拥有完整的知识产权，参赛作品不会涉及侵犯任何第三方肖像权、名誉权、隐私权等其他合法权益，如参赛作品引起任何法律纠纷，报名者本人将承担全部法律责任；SHISW展组委会拒绝任何可能与中国法律和意识形态相抵触的作品。<br>
                    3、所有个人及单位选送到本短片周的作品，即视为授予SHISW组委会在所有授权设立的展映环节的表演权及播放权，参赛作品的视频、静帧图像、中/英文字幕拷贝版、宣传片花可以用于SHISW组委会本次短片周的宣传活动及之后的相关展映活动，包括被新闻媒体报道、播出、制作宣传图册、书籍专刊出版及发表、电视台、网络、移动媒体及其它新媒体专题宣传展映专栏等。<br>
                    4、本活动主办方和组委会有权为活动宣传的目的使用报名者、短片作品相关权利人的姓名和肖像。<br>
                    5、本活动主办方有权保存入围影片，以作为放映及国际文化交流使用。<br>
                    6、短片作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈作品的国际展映、海外宣传推广、全球版权出售发行业务。<br>
                    7、本作品的导演同意授权本活动主办方和组委会作为经纪代理之一，洽谈本人的影视导演及相关商务工作。<br>
                    8、SHISW作品遴选、展映、评选规则最终解释权为SHISW主办方及组委会。<br>
                    9、提交资料后视为用户同意授权。<br>
                </div>
                <div v-if="typeId==1">
                    提交报名申请前，请您确认以下内容并选择同意授权：<br>
                    1.凡提交作品参展，即表示报名者同意接受SHISW组委会制定之所有参展细则章程。<br>
                    2.报名者一旦正式提交申请，即不得以任何理由擅自撤回已入选的作品。<br>
                    3.报名应确认对提交的作品拥有完整的知识产权，参赛作品不会涉及侵犯任何第三方肖像权、名誉权、隐私权等其他合法权益，如参赛作品引起任何法律纠纷，报名者本人将承担全部法律责任；SHISW展组委会拒绝任何可能与中国法律和意识形态相抵触的作品。<br>
                    4.本活动主办方和组委会有权为活动宣传的目的使用报名者相关权利人的姓名和肖像；有权为活动宣传的目的使用本作品简介与创作阐述中的内容；包括被新闻媒体报道、播出、制作宣传图册、书籍专刊出版及发表、电视台、网络、移动媒体及其它新媒体专题宣传展示专栏等。<br>
                    5.本活动主办方有权保存入围剧本，以作为国际文化交流使用。<br>
                    6.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈本作品的剧本版权、改编权的推广及出售业务。<br>
                    7.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈作者的影视编剧、相关撰稿及相关商务工作。<br>
                    8.SHISW作品遴选、展示、评选规则最终解释权为SHISW主办方及组委会。<br>
                    9、提交资料后视为用户同意授权。<br>
                </div>
                <div v-if="typeId==2">
                    提交报名申请前，请您确认以下内容并选择同意授权：<br>
                    1.凡提交作品参展，即表示报名者同意接受SHISW组委会制定之所有参展细则章程。<br>
                    2.报名者一旦正式提交申请，即不得以任何理由擅自撤回已入选的作品。<br>
                    3.报名应确认对提交的作品拥有完整的知识产权，参赛作品不会涉及侵犯任何第三方肖像权、名誉权、隐私权等其他合法权益，如参赛作品引起任何法律纠纷，报名者本人将承担全部法律责任；SHISW展组委会拒绝任何可能与中国法律和意识形态相抵触的作品。<br>
                    4.本活动主办方和组委会有权为活动宣传的目的使用报名者相关权利人的姓名和肖像；有权为活动宣传的目的使用本作品影评；包括被新闻媒体报道、播出、制作宣传图册、书籍专刊出版及发表、电视台、网络、移动媒体及其它新媒体专题宣传展示专栏等。<br>
                    5.本活动主办方有权保存入围影评，以作为国际文化交流使用。<br>
                    6.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈作者本人相关撰稿及相关商务工作。<br>
                    7.SHISW作品遴选、展示、评选规则最终解释权为SHISW主办方及组委会。<br>
                    8、提交资料后视为用户同意授权。<br>
                </div>
                <div v-if="typeId==3">
                    提交报名申请前，请您确认以下内容并选择同意授权：<br>
                    1.凡提交作品参展，即表示报名者同意接受SHISW组委会制定之所有参展细则章程。<br>
                    2.报名者一旦正式提交申请，即不得以任何理由擅自撤回已入选的作品。<br>
                    3.报名应确认对提交的作品拥有完整的知识产权，参赛作品不会涉及侵犯任何第三方肖像权、名誉权、隐私权等其他合法权益，如参赛作品引起任何法律纠纷，报名者本人将承担全部法律责任；SHISW展组委会拒绝任何可能与中国法律和意识形态相抵触的作品。<br>
                    4.本活动主办方和组委会有权为活动宣传的目的使用报名者相关权利人的姓名和肖像；有权为活动宣传的目的使用本作品简介与创作阐述中的内容；包括被新闻媒体报道、播出、制作宣传图册、书籍专刊出版及发表、电视台、网络、移动媒体及其它新媒体专题宣传展示专栏等。<br>
                    5.本活动主办方有权保存入围作品，以作为国际文化交流使用。<br>
                    6.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈关于本作品的相关合作业务。<br>
                    7.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈作者本人相关商务工作。<br>
                    8.SHISW作品遴选、展示、评选规则最终解释权为SHISW主办方及组委会。<br>
                    9、提交资料后视为用户同意授权。<br>
                </div>
                <div v-if="typeId==4">
                    提交报名申请前，请您确认以下内容并选择同意授权：<br>
                    1.凡提交作品参展，即表示报名者同意接受SHISW组委会制定之所有参展细则章程。<br>
                    2.报名者一旦正式提交申请，即不得以任何理由擅自撤回已入选的作品。<br>
                    3.报名应确认对提交的作品拥有完整的知识产权，参赛作品不会涉及侵犯任何第三方肖像权、名誉权、隐私权等其他合法权益，如参赛作品引起任何法律纠纷，报名者本人将承担全部法律责任；SHISW展组委会拒绝任何可能与中国法律和意识形态相抵触的作品。<br>
                    4.本活动主办方和组委会有权为活动宣传的目的使用报名者相关权利人的姓名和肖像；有权为活动宣传的目的使用本作品简介与创作阐述中的内容；包括被新闻媒体报道、播出、制作宣传图册、书籍专刊出版及发表、电视台、网络、移动媒体及其它新媒体专题宣传展示专栏等。<br>
                    5.本活动主办方有权保存入围作品，以作为国际文化交流使用。<br>
                    6.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈关于本作品的相关合作业务。<br>
                    7.本作品的作者同意授权本活动主办方和组委会作为经纪代理之一，洽谈作者本人相关商务工作。<br>
                    8.SHISW作品遴选、展示、评选规则最终解释权为SHISW主办方及组委会。<br>
                    9、提交资料后视为用户同意授权。<br>
                </div>
                <div v-if="typeId==5">
                    报名提交前您确认以下内容的授权，报名提交后授权即时生效：<br>
                    1、凡提交参赛资料，即表示报名者同意接受SHISW组委会制定之所有参赛细则章程。<br>
                    报名者一旦正式提交申请，即不得以任何理由擅自撤回；如参赛资料引起任何法律纠纷，报名者本人将承担全部法律责任；SHISW展组委会拒绝任何可能与中国法律和意识形态相抵触的参赛资料。<br>
                    2、参赛者提交的报名参赛资料即视为授予SHISW组委会在所有授权设立的展映环节与国际交流活动中的表演权及播放权，参赛资料中参赛者姓名、肖像权、静帧图像、视频、中/英文字幕拷贝版、宣传片花可以用于SHISW相关宣传、展映、交流活动，包括被新闻媒体报道、播出、制作宣传图册、书籍专刊出版及发表、电视台、网络、移动媒体及其它新媒体专题宣传展映专栏等。<br>
                    3、参赛者同意授权本活动主办方、活动平台方作为经纪代理之一，洽谈参赛者本人相关演艺与商务工作。<br>
                    4、SHISW遴选、评选等规则最终解释权为SHISW主办方及组委会。<br>
                    5、提交资料后视为用户同意授权。<br>
                </div>

                <!--<div class="t-right">
                    本人确认并同意授权 <el-radio v-model="formData.Agree" label="是"></el-radio>
                </div>-->
            </div>
            <div class="form" v-show="step==3">
                <div class="bold form-title">
                    报名提交的资料
                </div><br>
                <div v-if="typeId==0">
                    1、短片格式：1080P/2K/H.264/3G以内<br>
                    2、如有工作照3-5张，可提交<br>
                    3、如有预告片，可提交HD1080P<br>
                    4、百度网盘链接与密码有效期设置为永久<br>
                </div>
                <div v-if="typeId==1">
                    1、短片需提交完整剧本。<br>
                    2、长片入围者会通过邮件通知，需提交前二十五场戏或完整剧本，长片剧本需符合中国国家电影局审查立项标准。<br>
                    3、百度网盘链接与密码有效期设置为永久。<br>
                </div>
                <div v-if="typeId==3">
                    1、如有团队简历（包括演员与其他主创成员）、制作周期与预算表、手机样片、实拍外景地相片、人物造型设计、美术概念图、分镜头脚本等。<br>
                    2、百度网盘链接与密码有效期设置为永久。<br>
                </div>
                <div v-if="typeId==4">
                    1、短片创作者如作品已剪辑完成请提交完整作品；如制作中的未完成的短片请提交不少于2-5分钟的样片；格式要求：1080P/H.264/H.265/3G以内。<br>
                    2、原创音乐人需提提交1-3首已完成的作品，MP3（高音质）格式。<br>
                    3、如有海报、剧照、工作照、主创团队简介等，可提交。<br>
                    4、百度网盘链接与密码有效期设置为永久。<br>
                </div>
                <div v-if="typeId==5">
                    1、 个人简介<br>
                    2、 联系方式（手机号、微信号、邮箱）<br>
                    3、 免冠素颜照片1-3张<br>
                    4、 带妆形象照3-5张<br>
                    5、 影视代表作品（TVC、短片、电影至少1-2部完成的影片；电视剧至少1-2集完整的剧集；个人代表作品不接受片段视频，只接受完成影片。 ）<br>
                    6、 个人介绍视频<br>
                    7、 个人才艺展示视频<br>
                    8、 相关表演演出作品片段若干（可选）<br>
                    9、上述报名资料请上传百度网盘，百度网盘链接与密码有效期设置为永久，提交下载链接与密码。<br>
                </div>
                <div class="row f-center mt-10">
                    <div class="col-md-1">网盘链接：</div>
                    <div class="col-md-5"><input v-model="formData.WorkUrl" type="text" placeholder="" name="" id=""
                            class=""></div>
                </div>
                <div class="row f-center mt-10">
                    <div class="col-md-1">网盘密码：</div>
                    <div class="col-md-5"><input v-model="formData.WorkPwd" type="text" placeholder="" name="" id=""
                            class=""></div>
                </div>

                <div class="bg-f2f2f2 p-2 b-r-5 mt-4">
                    注意事项：<br>
                    1、鉴于参赛资料文件较大，内容较多，统一采用网盘收集作品；<br>
                    2、请确保参赛资料百度网盘链接正常打开，否则视为参赛无效；<br>
                    3、参赛选手只需提交一次报名资料；<br>
                    4、参赛资料修改保存后，平台将覆盖上次保存的数据；<br>
                    5、参赛资料提交确认后，不可修改，务必检查完整后提交。<br>
                    6、如在报名与提交过程中遇到任何问题，请发送邮件至shishortweek@hotmail.com，我们会及时回复您。<br>
                </div>
            </div>
            <div class="btn-group flex f-jcenter">
                <div class="btn-save" @click="save()">保存</div>
                <div class="btn-next" @click="last()" v-if="step!=0 && !(typeId==5 && step==2)">上一步</div>
                <div class="btn-next" @click="next()" v-if="step!=3 && !(typeId==2 && step==2)">下一步</div>
                <div class="btn-save" @click="submit()" v-if="step==3 || (typeId==2 && step==2)">提交</div>

            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../css/bootstrap.min.css";
    @import "../../../css/commons.css";
    .flex-1 {
        flex-grow: 1;
    }

    .body-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
    }

    .form {
        border: 1px solid #DCDFE6;
        margin-top: 20px;
        padding: 20px;
        border-radius: 5px;
    }

    .form-title {
        background-color: #fff;
        padding: 2px 5px;
        position: relative;
        top: -34px;
        left: 10px;
        display: inline-block;
    }

    .form input {
        background-color: #FFF;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        box-sizing: border-box;
        color: #606266;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        width: 100%;
    }

    .form .row {
        margin-top: 20px;
    }

    .btn-upload {
        width: 120px;
        height: 50px;
        line-height: 50px;
        background-color: #fb004d;
        color: #fff;
        border-radius: 5px;
    }

    .btn-group {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .btn-save,
    .btn-next {
        width: 120px;
        height: 50px;
        line-height: 50px;
        background-color: #fb004d;
        color: #fff;
        border-radius: 5px;
        margin-left: 20px;
        text-align: center;
        cursor: pointer;
    }

    .bg-f2f2f2 {
        background-color: #f2f2f2;
    }

    .b-r-5 {
        border-radius: 5px;
    }

    [v-cloak] {
        display: none;
    }
</style>
<script>
    import {getCompetitionDetail,postCompetitionSubmit,postBase64Upload} from "../../api.js";
    export default {
        name: "merge",
        data() {
            return {
                footbottom:123,
                pageTitle: '',//页面标题
                typeId: 0,//类型，参赛的类型
                step: 0,
                val: '',
                dialogVisible: false,
                imageUrl: [],
                formData: {//保存和提交的数据

                },
                fileList: {
                    Headimage: [],
                    Poster: [],
                    Stills: []
                },
                pageData: {
                    Name: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '姓名'
                    },
                    Gender: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '性别'
                    },
                    Company: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '毕业学校/单位'
                    },
                    VideoRole: {
                        page: [
                            {
                                typeId: 0,
                                step: 0,
                                title: '本人是这部作品的'
                            },
                            {
                                typeId: 1,
                                step: 0
                            },
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '申请者身份'
                    },
                    OccupationalStatus: {
                        page: [
                            {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                        ],
                        title: '职业状态'
                    },
                    Nation: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '民族'
                    },
                    Email: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '电子邮箱'
                    },
                    Phone: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '手机号码'
                    },
                    WxAccount: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '微信号'
                    },
                    Headimage: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            },
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '个人相片'
                    },
                    Resume: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0,
                                title: '影评人简历'
                            },
                            {
                                typeId: 3,
                                step: 0,
                                title: '艺术家简历'
                            },
                            {
                                typeId: 4,
                                step: 0,
                                title: '创作者简历'
                            }
                        ],
                        title: '简历'
                    },
                    Prize: {
                        page: [
                            {
                                typeId: 0,
                                step: 0
                            },
                            {
                                typeId: 1,
                                step: 0
                            }, {
                                typeId: 2,
                                step: 0
                            },
                            {
                                typeId: 3,
                                step: 0
                            }
                            ,
                            {
                                typeId: 4,
                                step: 0
                            }
                        ],
                        title: '荣誉奖项'
                    },
                    VideoName: {
                        page: [
                            {
                                typeId: 0,
                                step: 1,
                            },
                            {
                                typeId: 1,
                                step: 1
                            },
                            {
                                typeId: 3,
                                step: 1,
                            },
                            {
                                typeId: 4,
                                step: 1,
                            }
                        ],
                        title: '作品名称'
                    },//作品名称
                    FilmcriticsTitle: {
                        page: [
                            {
                                typeId: 2,
                                step: 1
                            }
                        ],
                        title: '影评文章名称'
                    },
                    VideoDuration: {
                        page: [
                            {
                                typeId: 0,
                                step: 1,
                                title: '影片时长'
                            }, {
                                typeId: 1,
                                step: 1,
                                title: '预计片长'
                            }, {
                                typeId: 3,
                                step: 1,
                                title: '预计片长'
                            }, {
                                typeId: 4,
                                step: 1,
                                title: '时长'
                            }

                        ],
                        title: '作品时长'
                    },//作品时长(分钟)
                    CompleteTime: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            },
                            {
                                typeId: 1,
                                step: 1
                            }
                        ],
                        title: '完成时间'
                    },//完成时间
                    FilmcriticsTime: {
                        page: [{
                            typeId: 2,
                            step: 1
                        }
                        ],
                        title: '影评完成时间'
                    },
                    VideoOverTime: {
                        page: [{
                            typeId: 3,
                            step: 1
                        },
                        {
                            typeId: 4,
                            step: 1
                        }
                        ],
                        title: '预计完成时间'
                    },
                    VideoCategory: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            },
                            {
                                typeId: 1,
                                step: 1
                            },
                            {
                                typeId: 3,
                                step: 1
                            },
                            {
                                typeId: 4,
                                step: 1
                            }
                        ],
                        title: '作品类型'
                    },//作品类型
                    VideoLanguage: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            },
                            {
                                typeId: 1,
                                step: 1
                            },
                            {
                                typeId: 3,
                                step: 1
                            },
                            {
                                typeId: 4,
                                step: 1
                            }
                        ],
                        title: '故事语言'
                    },//语言类型
                    Subtitle: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            }
                        ],
                        title: '字幕'
                    },//字幕
                    AgreeJoinSHISW: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            }
                        ],
                        title: '如果您的作品入选是否同意加入“SHISW线上影展'
                    },//如果您的作品入选是否同意加入“SHISW线上影展
                    Simple: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            },
                            {
                                typeId: 1,
                                step: 1
                            }
                        ],
                        title: '一句话梗概'
                    },//一句话概括
                    Summary: {
                        page: [
                            {
                                typeId: 0,
                                step: 1,
                                title: '故事简介'
                            },
                            {
                                typeId: 1,
                                step: 1,
                                title: '创作简介'
                            }, {
                                typeId: 3,
                                step: 1,
                                title: '创作简介'
                            }
                        ],
                        title: '简介'
                    },//作品简介
                    Elaboration: {
                        page: [
                            {
                                typeId: 0,
                                step: 1,
                                title: '导演阐述'
                            },
                            {
                                typeId: 1,
                                step: 1,
                                title: '创作阐述'
                            }, {
                                typeId: 3,
                                step: 1,
                                title: '创作阐述'
                            }, {
                                typeId: 4,
                                step: 1,
                                title: '创作阐述'
                            }
                        ],
                        title: '阐述'
                    },//导演阐述
                    FilmcriticsWords: {
                        page: [
                            {
                                typeId: 2,
                                step: 1
                            }
                        ],
                        title: '字数'
                    },
                    FilmcriticsVideoName: {
                        page: [
                            {
                                typeId: 2,
                                step: 1
                            }
                        ],
                        title: '影评电影名称'
                    },
                    FilmcriticsVideoType: {
                        page: [
                            {
                                typeId: 2,
                                step: 1
                            }
                        ],
                        title: '影评电影片长类型'
                    },
                    FilmcriticsContent: {
                        page: [
                            {
                                typeId: 2,
                                step: 1
                            }
                        ],
                        title: '影评正文'
                    },
                    Poster: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            }
                        ],
                        title: '海报'
                    },//海报
                    Stills: {
                        page: [
                            {
                                typeId: 0,
                                step: 1
                            }
                        ],
                        title: '剧照'
                    },//剧照
                    Agree: {
                        page: [
                            {
                                typeId: 0,
                                step: 2
                            },
                            {
                                typeId: 1,
                                step: 2
                            }, {
                                typeId: 2,
                                step: 2
                            }, {
                                typeId: 3,
                                step: 2
                            },
                            {
                                typeId: 4,
                                step: 2
                            },
                            {
                                typeId: 5,
                                step: 2
                            }
                        ],
                        title: '是否同意并授权'
                    },
                    WorkUrl: {
                        page: [
                            {
                                typeId: 0,
                                step: 3
                            },
                            {
                                typeId: 1,
                                step: 3
                            }, {
                                typeId: 3,
                                step: 3
                            }, {
                                typeId: 4,
                                step: 3
                            }, {
                                typeId: 5,
                                step: 3
                            }
                        ],
                        title: '网盘链接'
                    },
                    WorkPwd: {
                        page: [
                            {
                                typeId: 0,
                                step: 3
                            },
                            {
                                typeId: 1,
                                step: 3
                            }, {
                                typeId: 3,
                                step: 3
                            }, {
                                typeId: 4,
                                step: 3
                            }, {
                                typeId: 5,
                                step: 3
                            }
                        ],
                        title: '网盘密码'
                    },
                },
            };
        },
        created() {
            console.log("开始开发");

            this.typeId = this.$route.query.typeId || this.typeId;
            this.step = this.$route.query.step || this.step;
            this.getdetail();
            this.$nextTick(() => {
                if(document.getElementById("mergefoot").scrollHeight!=null&&document.getElementById("mergefoot").scrollHeight>0){
                    this.footbottom=document.getElementById("mergefoot").scrollHeight;
                }
            })
        },
        
        methods: {
            getdetail(){
                getCompetitionDetail({orderItemId:this.$route.query.Id}).then((res) => {
                    console.log(res);
                    //给formData增加属性和值
                    for (const key in this.pageData) {
                        let isAdd = this.pageData[key].page.some(item => {
                            return item.typeId == this.typeId
                        })
                        if (isAdd) {
                            if (res.data.Data && Object.hasOwnProperty.call(res.data.Data,key)) {
                                this.$set(this.formData, key, res.data.Data[key]);
                            } else {
                                this.$set(this.formData, key, '');
                            }
                        }
                    }
                    //获取图片数据
                    if (this.formData.Headimage) {
                        let arr = this.formData.Headimage.split(',')
                        for (let index = 0; index < arr.length; index++) {
                            this.fileList.Headimage.push({
                                key: 'Headimage',
                                url: arr[index]
                            })
                        }

                    }
                    if (this.formData.Poster) {
                        let arr = this.formData.Poster.split(',')
                        for (let index = 0; index < arr.length; index++) {
                            this.fileList.Poster.push({
                                key: 'Poster',
                                url: arr[index]
                            })
                        }
                    }
                    if (this.formData.Stills) {
                        let arr = this.formData.Stills.split(',')
                        for (let index = 0; index < arr.length; index++) {
                            this.fileList.Stills.push({
                                key: 'Stills',
                                url: arr[index]
                            })
                        }
                    }
                    console.log(this.formData)
                });
            },

            //显示弹框
            pupupShow(row) {
                console.log(row);
                this.dialogVisible = true;
            },
            //保存
            save() {

                //根据pageData和当前步骤，判断是否必填
                for (const key in this.formData) {
                    let showTitle = ''
                    let isRequired = this.pageData[key].page.some(item => {
                        if (item.step == this.step && item.typeId == this.typeId) {
                            if(this.pageData[key].title!="是否同意并授权"){
                                showTitle = item.title;
                                return true
                            }
                        }
                    })
                    //需要验证
                    if (isRequired) {
                        if (!this.formData[key]) {
                            //非空验证
                            if (showTitle) {
                                this.$message.error(showTitle + ' 数据为空')

                            } else {
                                this.$message.error(this.pageData[key].title + ' 数据为空')
                            }
                            return false
                        }

                        console.log(key)
                        //格式验证
                        if (key == 'Email') {
                            //var e = /^[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+$/
                            //if (!e.test(this.formData.Email)) {
                            //    this.$message.error('邮箱格式不正确！')
                            //    return false;
                            //}
                        }
                        if (key == 'Phone') {
                            var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
                            if (!reg.test(this.formData.Phone)) {
                                this.$message.error('手机格式不正确！')
                                return false;
                            }
                        }
                    }

                }

                //设置formData默认属性
                let formData = Object.assign({}, this.formData, {
                    OrderItemId: this.$route.query.Id,
                    Type: 1
                })
                postCompetitionSubmit(formData).then(res => {
                    if (res.data.Code != 0) {
                        alert(res.data.Message)
                        return
                    }
                    this.$message.success('已保存')
                })
            },
            //上一步
            last() {
                if (this.step > 0) {
                    this.step--
                }
            },
            //下一步
            next() {
                if (this.step < 3) {
                    this.step++
                }
            },
            //提交
            submit() {
                //数据验证
                //根据pageData和当前步骤，判断是否必填
                for (const key in this.formData) {
                    let showTitle = ''
                    let isRequired = this.pageData[key].page.some(item => {
                        if (item.step == this.step && item.typeId == this.typeId) {
                            if(this.pageData[key].title!="是否同意并授权"){
                                showTitle = item.title;
                                return true
                            }
                        }
                    })
                    //需要验证
                    if (isRequired) {
                        if (!this.formData[key]) {
                            //非空验证
                            if (showTitle) {
                                this.$message.error(showTitle + ' 数据为空')

                            } else {
                                this.$message.error(this.pageData[key].title + ' 数据为空')
                            }
                            return false
                        }

                        console.log(key)
                        //格式验证
                        if (key == 'Email') {
                            //var e = /^[\da-z]+([\-\.\_]?[\da-z]+)*@[\da-z]+([\-\.]?[\da-z]+)*(\.[a-z]{2,})+$/
                            //if (!e.test(this.formData.Email)) {
                            //    this.$message.error('邮箱格式不正确！')
                            //    return false;
                            //}
                        }
                        if (key == 'Phone') {
                            var reg = 11 && /^((13|14|15|17|18|16|19|11|12)[0-9]{1}\d{8})$/;
                            if (!reg.test(this.formData.Phone)) {
                                this.$message.error('手机格式不正确！')
                                return false;
                            }
                        }
                    }
                }


                //设置formData默认属性
                let formData = Object.assign({}, this.formData, {
                    OrderItemId: this.$route.query.Id,
                    Token: localStorage.getItem('AccessToken'),
                    Type: 2
                })
                postCompetitionSubmit(formData).then(res => {
                    if (res.data.Code != 0) {
                        alert(res.data.Message)
                        return
                    }
                    this.$message.success('已提交')
                    
                    this.$router.push("/merge/mycompetition");
                })
            },
            handleRemove(file) {
                console.log('删除',file)

                let array = this.formData[file.key].split(',')
                for (let index = 0; index < array.length; index++) {
                    if (array[index] == file.url) {
                        array.splice(index, 1)
                        break
                    }
                }

                this.formData[file.key] = array.join(',')

                let array2 = this.fileList[file.key]
                for (let index = 0; index < array2.length; index++) {
                    if (array2[index].url == file.url) {
                        array2.splice(index, 1)
                        break
                    }
                }

                this.fileList[file.key] = array2

                console.log(this.formData)
                console.log(this.fileList)
            },
            //上传成功
            handSuccess(e) {
                console.log('上传成功')
                console.log(e)
            },
            //文件上传，自定义上传方式
            httpRequest(e) {
                // console.log(e)
                var _this=this;
                _this.getBase64(e.file).then(res => {
                    var data={
                        Base64: res,
                        Folder: 'sign'
                    }
                    postBase64Upload(data).then(res => {
                        if (res.data.Code != 0) {
                            alert(res.data.Message)
                            return false
                        }
                        let arr = []
                        if (_this.formData[e.data].length != 0) {
                            arr = _this.formData[e.data].split(',')
                        }
                        arr.push(res.data.Data.FilePath)
                        _this.formData[e.data] = arr.join(',')

                        _this.fileList[e.data].push({
                            key: e.data,
                            url: res.data.Data.FilePath
                        })

                        return true
                    })
                })
            },
            // 获取图片转base64
            getBase64(file) {
                return new Promise(function (resolve, reject) {
                    const reader = new FileReader()
                    let imgResult = ''
                    reader.readAsDataURL(file)
                    reader.onload = function () {
                        imgResult = reader.result
                    }
                    reader.onerror = function (error) {
                        reject(error)
                    }
                    reader.onloadend = function () {
                        resolve(imgResult)
                    }
                })
            },
            handlePictureCardPreview(file) {
                console.log(file);
                // this.dialogImageUrl = file.url;
                // this.dialogVisible = true;
            },
            //图片上传前-个人照
            beforeAvatarUploadHeadimage(file) {
                const isLt2M = file.size / 1024 / 1024 < 3;
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 3MB!');
                    return false;
                }
                return true;
            },
            //图片上传前-剧照
            beforeAvatarUploadStills(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isLt5M) {
                    this.$message.error('上传剧照图片大小不能超过 5MB!');
                    return false;
                }
                return true;
            },
            //图片上传前-海报
            beforeAvatarUploadPoster(file) {
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isLt5M) {
                    this.$message.error('上传海报图片大小不能超过 5MB!');
                    return false;
                }
                return true;
            },
            //跳转链接
            toBanerHref() {
                let i = this.$refs.carousel.activeIndex;
                let item = this.bannerlist[i];
                console.log(item);
                if (!item.Href) {
                    return;
                } else {
                    location.href = item.Href;
                }
            },
            toPage(url){
                this.$router.push("/merge/"+url);
            }
        },
    };
</script>
